import {
    DELETED_ORG_UNIT_LABEL,
    NO_ORG_UNIT,
    NO_ORG_UNIT_LABEL,
    UNAVAILABLE_ORG_UNIT_LABEL,
} from '~/constants/orgUnit';
import { orgUnitsClient } from '~/services';
import type { OrgUnit } from '~/types/orgUnit.types';
import { chunkArray } from '~/utils/array';

const IDS_PER_REQUEST = 10;

export interface OrgUnitsByIds {
    names: Map<string, string>;
    failedIds: Set<string>;
}

export const fetchOrgUnitsByIds = async (teamId: number, ids: string[]): Promise<OrgUnitsByIds> => {
    const names = new Map<string, string>();
    const failedIds = new Set<string>();

    await Promise.all(
        chunkArray(
            [...new Set(ids)].filter((id) => id !== NO_ORG_UNIT),
            IDS_PER_REQUEST
        ).map(async (batch) => {
            try {
                const response = await orgUnitsClient.listOrgUnits(teamId, { ids: batch, per_page: batch.length });
                response.data.data.forEach((orgUnit: OrgUnit) => names.set(String(orgUnit.id), orgUnit.name));
            } catch {
                batch.forEach((id) => failedIds.add(id));
            }
        })
    );

    return { names, failedIds };
};

export const orgUnitName = ({ names, failedIds }: OrgUnitsByIds, id: string): string => {
    if (id === NO_ORG_UNIT) {
        return NO_ORG_UNIT_LABEL;
    }

    return names.get(id) ?? (failedIds.has(id) ? UNAVAILABLE_ORG_UNIT_LABEL : DELETED_ORG_UNIT_LABEL);
};
